import '@achievement-workshop/achievement-workshop.scss'
import AchievementWorkshop, {type Props} from '@achievement-workshop/components/AchievementWorkshop.tsx'
import QueryClientProvider from '@common/components/QueryClientProvider.tsx'
import bootstrap from '@common/libs/bootstrap.tsx'
import {StrictMode} from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'

declare global {
    const oicoAchievementWorkshop: Props & {
        basename: string
        root_id: string
    }
}

const {basename, root_id, ...props} = oicoAchievementWorkshop

bootstrap(
    root_id,
    'oicoAchievementWorkshop',
    <StrictMode>
        <QueryClientProvider>
            <BrowserRouter basename={basename}>
                <Routes>
                    <Route
                        element={<AchievementWorkshop {...props} />}
                        path="/"
                    />
                </Routes>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
)
